// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountTitle_container__2uCuo","greetings":"AccountTitle_greetings__1fs_1","title":"AccountTitle_title__-zaR3"};